// import React from "react";
// import { motion } from "framer-motion";
// import {
//   ArrowRight,
//   Cpu,
//   Globe2,
//   Rocket,
//   Heart,
//   Mail,
//   Zap,
//   CheckCircle2,
//   CalendarClock,
//   Briefcase,
// } from "lucide-react";

// const fadeUp = {
//   initial: { opacity: 0, y: 20 },
//   whileInView: { opacity: 1, y: 0 },
//   viewport: { once: true },
//   transition: { duration: 0.6 },
// };

// export default function CareersPage() {
//   const values = [
//     {
//       icon: Rocket,
//       t: "Impact Driven",
//       d: "We build systems that solve real-world enterprise problems at scale, ensuring every line of code adds value.",
//       tag: "Scale",
//     },
//     {
//       icon: Cpu,
//       t: "Tech First",
//       d: "Work with the latest stacks: React, FastAPI, AWS, and LLM architectures. We don't settle for legacy.",
//       tag: "Modern",
//     },
//     {
//       icon: Heart,
//       t: "Radical Candor",
//       d: "We value direct, honest feedback and authentic collaboration. No politics, just engineering excellence.",
//       tag: "Culture",
//     },
//     {
//       icon: Globe2,
//       t: "Remote DNA",
//       d: "Flexibility is our foundation. Work from where you are most productive, across any time zone.",
//       tag: "Remote",
//     },
//   ];

//   return (
//     <main className="min-h-screen bg-white font-inter selection:bg-indigo-100 text-slate-900">
//       {/* ================= HERO SECTION ================= */}
//       <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
//         <div
//           className="absolute inset-0 bg-cover bg-center opacity-10"
//           style={{
//             backgroundImage:
//               "url('https://images.unsplash.com/photo-1522071823991-b9671f9d7f1f?w=1920&q=80')",
//           }}
//         />
//         <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

//         <div
//           className="absolute inset-0 opacity-[0.05] pointer-events-none"
//           style={{
//             backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
//             backgroundSize: "30px 30px",
//           }}
//         />

//         <div className="relative max-w-7xl mx-auto px-6 w-full text-left">
//           <motion.div
//             initial={{ opacity: 0, x: -20 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.8 }}
//             className="max-w-2xl"
//           >
//             <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.2em] uppercase mb-6 text-left">
//               Careers at Infronex
//             </div>
//             <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight leading-tight text-left">
//               Built by Engineers, <br />
//               <span className="text-indigo-400">For Engineers.</span>
//             </h1>
//             <p className="text-lg text-slate-300 mb-8 leading-relaxed font-light text-left">
//               We are a team of authentic collaborators building high-fidelity
//               software and data ecosystems. Join a culture where your craft is
//               respected.
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* ================= CULTURE & VALUES (REFINED CARDS) ================= */}
//       <section className="py-24 bg-white">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="text-left mb-16">
//             <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
//               Our Core Philosophy
//             </span>
//             <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight text-left">
//               Engineering-First Culture
//             </h2>
//           </div>

//           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {values.map((v, i) => (
//               <motion.div
//                 key={i}
//                 {...fadeUp}
//                 transition={{ delay: i * 0.1 }}
//                 className="group p-8 rounded-3xl border border-slate-100 bg-slate-50/30 hover:bg-white hover:border-indigo-100 hover:shadow-2xl hover:shadow-indigo-500/5 transition-all duration-300 flex flex-col items-start text-left"
//               >
//                 <div className="w-12 h-12 bg-white border border-slate-100 shadow-sm flex items-center justify-center rounded-2xl text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-all mb-8">
//                   <v.icon size={22} />
//                 </div>
//                 <span className="text-[10px] font-black text-indigo-600/40 uppercase tracking-widest mb-2">
//                   {v.tag}
//                 </span>
//                 <h4 className="text-xl font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
//                   {v.t}
//                 </h4>
//                 <p className="text-sm text-slate-500 font-light leading-relaxed">
//                   {v.d}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ================= NO OPENINGS SECTION (INDUSTRIAL TECH STYLE) ================= */}
//       <section className="py-24 bg-slate-50 border-y border-slate-100">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="bg-[#0f172a] rounded-[3rem] p-10 md:p-20 relative overflow-hidden text-center">
//             {/* Visual Decoration */}
//             <div className="absolute top-0 right-0 w-96 h-96 bg-indigo-500/10 blur-[120px] rounded-full" />
//             <div className="absolute bottom-0 left-0 w-64 h-64 bg-indigo-600/5 blur-[80px] rounded-full" />

//             <div className="relative z-10 max-w-2xl mx-auto">
//               <div className="w-16 h-16 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center text-indigo-400 mx-auto mb-8">
//                 <CalendarClock size={32} strokeWidth={1.5} />
//               </div>
//               <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 tracking-tight">
//                 Preparing for{" "}
//                 <span className="text-slate-500 text-left">Future Growth.</span>
//               </h2>
//               <p className="text-slate-400 text-lg font-light leading-relaxed mb-10 text-center">
//                 While we don't have any active openings at this moment, we are
//                 constantly scaling our engineering and data teams. We recommend
//                 checking back soon for opportunities in AI training and
//                 full-stack development.
//               </p>

//               <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
//                 <div className="px-6 py-4 bg-white/5 border border-white/10 rounded-2xl flex items-center gap-3 w-full sm:w-auto">
//                   <Mail className="text-indigo-400" size={18} />
//                   <span className="text-sm font-medium text-slate-300">
//                     careers@infronex.com
//                   </span>
//                 </div>
//                 <button className="bg-indigo-600 text-white px-8 py-4 rounded-2xl text-sm font-bold hover:bg-indigo-700 transition-all shadow-xl shadow-indigo-900/20 flex items-center gap-2 w-full sm:w-auto justify-center">
//                   Submit Speculative CV <ArrowRight size={16} />
//                 </button>
//               </div>

//               <div className="mt-12 pt-12 border-t border-white/5 flex flex-wrap justify-center gap-8">
//                 {[
//                   { icon: Briefcase, label: "Full-Time Roles" },
//                   { icon: Zap, label: "Contractor Network" },
//                   { icon: Globe2, label: "Remote Options" },
//                 ].map((item, i) => (
//                   <div
//                     key={i}
//                     className="flex items-center gap-2 text-slate-500 text-xs font-bold uppercase tracking-widest"
//                   >
//                     <item.icon size={14} className="text-slate-600" />{" "}
//                     {item.label}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ================= FINAL CTA ================= */}
//       <section className="py-24 bg-white text-center">
//         <div className="max-w-4xl mx-auto px-6">
//           <h2 className="text-3xl font-bold text-slate-900 mb-6 tracking-tight text-center">
//             Stay in the Loop
//           </h2>
//           <p className="text-slate-500 mb-10 text-lg font-light leading-relaxed text-center">
//             Follow our journey on LinkedIn to be the first to know when we open
//             new positions in engineering, data science, and infrastructure.
//           </p>
//           <div className="flex justify-center">
//             <button className="bg-[#0f172a] text-white px-10 py-3.5 rounded-xl font-bold text-sm hover:bg-indigo-600 transition-all shadow-xl">
//               Follow Infronex
//             </button>
//           </div>
//         </div>
//       </section>
//     </main>
//   );
// }

import React from "react";
import { motion } from "framer-motion";
import {
  ArrowRight,
  Cpu,
  Globe2,
  Rocket,
  Heart,
  Mail,
  Zap,
  CheckCircle2,
  CalendarClock,
  Briefcase,
} from "lucide-react";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function CareersPage() {
  const values = [
    {
      icon: Rocket,
      t: "Impact Driven",
      d: "We build systems that solve real-world enterprise problems at scale, ensuring every line of code adds value.",
      tag: "Scale",
    },
    {
      icon: Cpu,
      t: "Tech First",
      d: "Work with the latest stacks: React, FastAPI, AWS, and LLM architectures. We don't settle for legacy.",
      tag: "Modern",
    },
    {
      icon: Heart,
      t: "Radical Candor",
      d: "We value direct, honest feedback and authentic collaboration. No politics, just engineering excellence.",
      tag: "Culture",
    },
    {
      icon: Globe2,
      t: "Remote DNA",
      d: "Flexibility is our foundation. Work from where you are most productive, across any time zone.",
      tag: "Remote",
    },
  ];

  return (
    <main className="min-h-screen bg-white font-inter selection:bg-indigo-100 text-slate-900">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-10"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1522071823991-b9671f9d7f1f?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full text-left">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.2em] uppercase mb-6 text-left">
              Careers at Infronex
            </div>
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight leading-tight text-left">
              Built by Engineers, <br />
              <span className="text-indigo-400">For Engineers.</span>
            </h1>
            <p className="text-lg text-slate-300 mb-8 leading-relaxed font-light text-left">
              We are a team of authentic collaborators building high-fidelity
              software and data ecosystems. Join a culture where your craft is
              respected.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ================= CULTURE & VALUES (FIXED HOVER) ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-left mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Our Core Philosophy
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight text-left">
              Engineering-First Culture
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v, i) => (
              <motion.div
                key={i}
                {...fadeUp}
                transition={{ delay: i * 0.1 }}
                className="group p-8 rounded-3xl border border-slate-100 bg-slate-50/30 hover:bg-white hover:border-indigo-100 hover:shadow-2xl hover:shadow-indigo-500/5 transition-all duration-300 flex flex-col items-start text-left"
              >
                {/* Icon Container: icon turns white when parent group is hovered */}
                <div className="w-12 h-12 bg-white border border-slate-100 shadow-sm flex items-center justify-center rounded-2xl text-indigo-600 group-hover:bg-indigo-600 group-hover:text-black transition-all duration-300 mb-8">
                  <v.icon size={22} />
                </div>
                <span className="text-[10px] font-black text-indigo-600/40 uppercase tracking-widest mb-2">
                  {v.tag}
                </span>
                <h4 className="text-xl font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                  {v.t}
                </h4>
                <p className="text-sm text-slate-500 font-light leading-relaxed">
                  {v.d}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= NO OPENINGS SECTION ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-[#0f172a] rounded-[3rem] p-10 md:p-20 relative overflow-hidden text-center">
            <div className="absolute top-0 right-0 w-96 h-96 bg-indigo-500/10 blur-[120px] rounded-full" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-indigo-600/5 blur-[80px] rounded-full" />

            <div className="relative z-10 max-w-2xl mx-auto">
              <div className="w-16 h-16 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center text-indigo-400 mx-auto mb-8">
                <CalendarClock size={32} strokeWidth={1.5} />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 tracking-tight">
                Preparing for{" "}
                <span className="text-slate-500">Future Growth.</span>
              </h2>
              <p className="text-slate-400 text-lg font-light leading-relaxed mb-10 text-center">
                While we don't have any active openings at this moment, we are
                constantly scaling our engineering and data teams. We recommend
                checking back soon.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="mailto:info@infronex.com"
                  className="px-6 py-4 bg-white/5 border border-white/10 rounded-2xl flex items-center gap-3 w-full sm:w-auto hover:bg-white/10 transition-colors"
                >
                  <Mail className="text-indigo-400" size={18} />
                  <span className="text-sm font-medium text-slate-300">
                    info@infronex.com
                  </span>
                </a>
                {/* <a
                  href="mailto:info@infronex.com?subject=Speculative CV Application"
                  className="bg-indigo-600 text-white px-8 py-4 rounded-2xl text-sm font-bold hover:bg-indigo-700 transition-all shadow-xl shadow-indigo-900/20 flex items-center gap-2 w-full sm:w-auto justify-center"
                >
                  Submit Speculative CV <ArrowRight size={16} />
                </a> */}
              </div>

              <div className="mt-12 pt-12 border-t border-white/5 flex flex-wrap justify-center gap-8">
                {[
                  { icon: Briefcase, label: "Full-Time Roles" },
                  { icon: Zap, label: "Contractor Network" },
                  { icon: Globe2, label: "Remote Options" },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-2 text-slate-500 text-xs font-bold uppercase tracking-widest"
                  >
                    <item.icon size={14} className="text-slate-600" />{" "}
                    {item.label}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA (LINKEDIN UPDATE) ================= */}
      <section className="py-24 bg-white text-center">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-slate-900 mb-6 tracking-tight text-center">
            Stay in the Loop
          </h2>
          <p className="text-slate-500 mb-10 text-lg font-light leading-relaxed text-center">
            Follow our journey on LinkedIn to be the first to know when we open
            new positions in engineering, data science, and infrastructure.
          </p>
          <div className="flex justify-center">
            <a
              href="https://www.linkedin.com/company/infronex-it-products-and-service"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#0f172a] text-white px-10 py-3.5 rounded-xl font-bold text-sm hover:bg-indigo-600 transition-all shadow-xl"
            >
              Follow Infronex
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}